import { createSlice } from '@reduxjs/toolkit';
import { getLegacyTiposTraccion } from '../legacy/thunk.js';

export const initialState = {
    legacyTiposTraccion: [],
    loading: false,
    error: {},
};

const legacyTiposTraccionSlice = createSlice({
    name: 'legacyTiposTraccion',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getLegacyTiposTraccion.fulfilled, (state, action) => {
            state.legacyTiposTraccion = action.payload;
            state.loading = true;
        });
        builder.addCase(getLegacyTiposTraccion.rejected, (state, action) => {
            state.error = action.payload.error || null;
            state.loading = true;
        });
        builder.addCase(getLegacyTiposTraccion.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
    }
});

export default legacyTiposTraccionSlice.reducer;